import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ChatbotApiClient from "../../../../methods/api/chatbotapiClient";
import loader from "../../../../methods/loader";
import { ChatbotContext } from '../../TabContextProvider';
import moment from 'moment';
import LiveAgentTimings from './LiveAgentTiming';
import { useSelector } from 'react-redux';
import methodModel from '../../../../methods/methods';
import Button from '../../../../components/alerts/Button';
import Checkbox from '../../../../components/checkbox/checkbox';
import swal from 'sweetalert'
import SettingsNotification from './SettingsNotification';
import IdleTiming from './Idletime';
class DateDisplay extends React.Component {
  render() {
    // Assuming date is passed as props
    const { date } = this.props;

    // Format the date using moment
    const formattedDate = moment(date).format("MMMM DD, YYYY [at] hh:mm A");

    return <div>{formattedDate}</div>;
  }
}

const InformationNestTab = () => {
  const SubscriptionData = useSelector(state => state.Subscription);
  const { chatbotData, setChatbotData } = React.useContext(ChatbotContext);

  const [chatbot_name, setchatbot_name] = useState(chatbotData?.chatbot_name)
  const handleInputChange = (event) => {
    setchatbot_name(event.target.value);
  };
  const saveToDatabase = async () => {

    if (chatbot_name === "") {
      swal({text:"Please enter a chatbot name.",icon:'error',className:'smallModal'})
      return;
    }

    let payload = {
      chatbot_name: chatbot_name,

    };
    loader(true)
    await ChatbotApiClient.post(`api/update_chatbot/${chatbotData.id}/`, payload).then(async res => {
      const response = await res;
      if (response.chatbot) {
        setChatbotData(response.chatbot);
        swal({text:"Details saved successfully",icon:'success',className:'smallModal'})
        loader(false);

      }
    });
  };
  const user = useSelector(state => state.user);


  const [isChecked, setIsChecked] = useState(false);
  const [activeTab, setActiveTab] = useState(chatbotData?.chatbot_type);
  const [Saving, setSaving] = useState(false)
  const [Saved, setSaved] = useState(true)
  const ChatbotTypeUpdater = (type = '') => {
    setSaving(true)
    setChatbotData(prev => ({ ...prev, chatbot_type: type }))
    ChatbotApiClient.post(`api/update-chatbot-type/`, { chatbot_id: chatbotData?.id || chatbotData?._id, chatbot_type: type }).then(res => {
      if (res.success) {
        setSaved(true)
      }
      setSaving(false)
    })
  }

  return (
    <div className=''>
 
      <div className=''>
        <div className="shadow-box border border-gray-5 bg-white rounded-md mb-4 ">
          {/* Tabs */}
          <div className="py-4 px-5 border-b border-gray-5">
            <h5 className="text-base font-medium text-[#2B2B2B] leading-5 traclcking-[0.2px]">
              Select the version of Chatbot
            </h5>
          </div>

          <div className="flex flex-wrap gap-2 p-5 ">
            {["simple", "advanced"].map((tab) => (
              <label className="flex items-center gap-1.5 mr-3">
                <Checkbox
                disabled={tab=='simple'?!SubscriptionData?.includes('knowledge-chatbot'):!SubscriptionData?.includes('transactional-chatbot')}
                  checked={activeTab === tab&&SubscriptionData.includes(tab=='simple'?'knowledge-chatbot':'transactional-chatbot')}
                  
                  onChange={() => {
                    setSaved(false)
                    setActiveTab(tab);
                  }}
                />
                <span className="text-typo text-sm font-medium mb-0 whitespace-nowrap capitalize cursor-pointer">
                  {tab === "simple" ? "knowledge Base" : "Advanced"}
                </span>
              </label>
            ))}
          </div>
          <div className="px-3 py-3.5 flex justify-end">
            <Button
              onClick={() => ChatbotTypeUpdater(activeTab)}
              disabled={Saving || Saved}
              className="ml-auto w-[100px]"
              type="button"
            >
              {Saving ? 'Saving' : Saved ? 'Saved' : 'Save'}
            </Button>
          </div>
        </div>
      </div>

    {methodModel.CurrentServer()&& <IdleTiming chatbotData={chatbotData} setChatbotData={setChatbotData}/>}
<SettingsNotification/>
   
      {/* } */}



      {/*  Live Agent Timings */}
      <div className=''>
        <div className="shadow-box border border-gray-5 bg-white rounded-md mb-4">
          <div className="py-4 px-5 border-b border-gray-5">
            <h5 className="text-base font-medium text-[#2B2B2B] leading-5 traclcking-[0.2px]">
              Live Agent Timings
            </h5>
          </div>
          <div className='p-4'>
            <div className=''>
              <LiveAgentTimings />
            </div>

          </div>
        </div>
      </div>
      <div className="shadow-box border border-gray-5 bg-white rounded-md mb-4">
        <div className="py-4 px-5 border-b border-gray-5">
          <h5 className="text-base font-medium text-[#2B2B2B] leading-5 traclcking-[0.2px]">
            General
          </h5>
        </div>
        <div className="p-4">
          <p className="text-sm text-[#2B2B2B]/70 mb-3">Chatbot ID</p>
          <div className="flex items-center gap-4">
            <h5 className="text-sm font-medium text-[#2B2B2B] leading-5">
              {chatbotData?.chatbot_id}
            </h5>
            <img src={methodModel.userImg(user?.logo)} className="h-16 w-16 object-contain rounded-large " />
          </div>
          <p className="text-sm text-[#2B2B2B]/70 mt-12 mb-4">
            Number of characters
          </p>
          <h5 className="text-sm font-medium text-[#2B2B2B] leading-5">
            {chatbotData?.char_sum}
          </h5>
          <label
            htmlFor=""
            className="text-sm text-[#2B2B2B] leading-none inline-block mt-6 mb-2">
            Name
          </label>
          <input
            type="text"
            name=""
            id=""
            onChange={handleInputChange}
            className="shadow-box border border-gray-5 w-full h-12 font-light px-3.5 rounded-large text-sm leading-6 text-gray-900 focus:outline-none focus:ring-1 ring-[#115B9D]-2"
            value={chatbot_name}
          />
        </div>
      </div>
      <div className="shadow-box border border-gray-5 bg-white rounded-md mb-4">
        <div className="py-4 px-5 border-b border-gray-5">
          <h5 className="text-base font-medium text-[#2B2B2B] leading-5 traclcking-[0.2px]">
            Training
          </h5>
        </div>
        <div className="p-6">
          <p className="text-sm text-[#2B2B2BB2] leading-none font-light">
            Last Trained
          </p>
          <h5 className="text-sm font-medium text-[#2B2B2B] leading-5 mt-4">
            {chatbotData?.last_train_model ? <DateDisplay date={chatbotData?.last_train_model} /> : '---'}
          </h5>
        </div>

      </div>
      <div className="flex justify-end">
        <Button
          onClick={saveToDatabase}
          className="ml-auto w-[100px]"
          type="button"
        >
          Submit
        </Button>
      </div>
    </div >
  );
};

export default InformationNestTab;
